// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreAccounting = (client) => ({
    /**
     * `GET /store/accounting/:seller_id/:kind`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetSellerAccountingSnapshot
     * @source apps/backend/src/api/store/accounting/[seller_id]/[kind]/route.ts
     */
    retrieve: (sellerId, kind, query, headers) => client.fetch(buildPath("/store/accounting/:seller_id/:kind", [sellerId, kind]), { method: "GET", query, headers }),
});
//# sourceMappingURL=accounting.js.map